import type { Recipe } from "@/types/recipe";
import type { I18n } from "@lingui/core";
import { msg } from "@lingui/core/macro";
import { toSubIngredientRows } from "../ingredient-rows";
import type { PrepRecipeRow } from "./types";
import { getPrepRecipeColumns } from "./columns";

/** Maps API Recipe → PrepRecipeRow for table display */
export function toPrepRecipeRows(
  recipes: Recipe[],
  organizationNamesById: Record<number, string> | undefined,
  i18n: I18n,
): PrepRecipeRow[] {
  return recipes.map((r) => ({
    id: r.id,
    prepRecipeId: r.slug,
    name: r.name,
    organizationName:
      typeof r.organizationId === "number"
        ? (organizationNamesById?.[r.organizationId] ?? String(r.organizationId))
        : undefined,
    companyName: r.company?.name,
    imageUrl: r.imageUrl,
    timeToPrep: r.prepTimeMinutes ? i18n._(msg`${r.prepTimeMinutes} min`) : undefined,
    yield: r.servings ? `${r.servings}` : undefined,
    ingredientCount: r._count?.ingredients ?? r.ingredients?.length ?? 0,
    allergenCount: r.allergens?.length ?? 0,
    ingredients: toSubIngredientRows(r),
  }));
}

export const prepRecipeListColumns = (i18n: I18n) => getPrepRecipeColumns(i18n);
export const prepRecipePanelColumns = (i18n: I18n) => getPrepRecipeColumns(i18n, { expandable: true });
